/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Scope_Point_1Inputs */

const en_svc_agents_scope_point_1 = /** @type {(inputs: Svc_Agents_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead qualification and sales follow-ups`)
};

const lv_svc_agents_scope_point_1 = /** @type {(inputs: Svc_Agents_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālo klientu izvērtēšana un pārdošanas sarunu turpināšana`)
};

/**
* | output |
* | --- |
* | "Lead qualification and sales follow-ups" |
*
* @param {Svc_Agents_Scope_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_scope_point_1 = /** @type {((inputs?: Svc_Agents_Scope_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Scope_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_scope_point_1(inputs)
	return en_svc_agents_scope_point_1(inputs)
});